export default __webpack_public_path__ + "857697c5bd701ec1a850f721ee2b8b6c.jpg";